


<template lang="jade">

	div.privacy
		div.privacy-content
			h1 Privacy Policy

			h2 Your Right to Privacy
			p NXTGEN is committed to keeping your personal information private. We are dedicated to providing you with superior service while protecting your privacy and safeguarding your personal information.

			h2 Consent
			p By submitting personal information to NXTGEN or our assignees, service providers or agents, you agree that we may collect, use and disclose your personal information in accordance with this Privacy Policy.

			h2 Change to Privacy Policy
			p In order to ensure that this Privacy Policy is kept up to date, we reserve the right to change it from time to time. Notice of changes may be distributed through NXTGEN statements, newsletters, posted to the NXTGEN website or other similar means. If you access or choose to continue to be serviced by NXTGEN after the effective date of the change, you automatically accept the change.

			h2 Collection of Personal Information
			p This Privacy Policy applies to all personal information that we collect. This Privacy Policy does not apply to business information. NXTGEN does however protect the confidentiality of such information in accordance with the law and NXTGEN’s policies.
			p To provide you with our products and services, we may collect the following personal information:

			p
				ul
					li Contact and mailing information such as name, address, telephone number, fax numbers and e-mail address;
					li Employment information, credit information and personal references of those who are applying for credit;
					li Type, number and place of issuance of documents provided in support of your identity;
					li Insurance information;
					li Details on directors and owners of businesses;
					li Dates of birth; and
					li Any other relevant information that is necessary to provide you with our products and services.

			p When you visit our Web site, we may collect information about your use of our products and services, which is captured in a common log file format, including your Internet Protocol address and operating system, the date and time of your visit and information about the pages you visit while on our web site. To assist us in collecting information when you visit us online, we may use electronic technologies such as cookies (small computer files saved to your hard drive) which help us understand what parts of our products and services you find most useful. You can reject cookies, but sometimes this compromises the functionality of the product or service.

			h2 Use of Personal Information
			p NXTGEN collects personal information in order to:

			p
				ul
					li open, maintain, service, process, analyze, survey, audit and collect on your account;
					li verify your identity and credit worthiness;
					li protect you from identity theft, fraud and unauthorized access to your account;
					li determine your eligibility, administer and contact you for the purposes of marketing, promotions, research or contests;
					li Obtain from and share with consumer reporting agencies, credit or mortgage insurers and other parties who have financial, employment or business dealings with you application and transaction information;
					li To improve the quality and efficiency of our products and services, analyze our portfolio and to enhance our marketing efforts; and
					li Use for any purpose required by law.

			p NXTGEN and our assignees, service providers or agents may use any method to contact you (including mail, phone, e-mail) using your contact information unless you have opted-out of a particular channel. Even when you have opted out, we may still be required to contact you when legal reasons arise (for example, we may use mail to send you disclosures) or business needs arise (for example, to alert you if there has been fraud on your account).

</template>



<script>



	let $cmp = {
		name : 'privacy'
	}



	$cmp.data = function() {
		return {
			date : new Date().getFullYear()
		}
	}



	$cmp.mounted = function() {

	}



	export default $cmp



</script>



<style lang="stylus">

	.privacy
		position relative
		width 100%
		height 100%
		color #FFFFFF
		overflow-x hidden

		h1
			font-size 24px
			margin-bottom 20px

	.privacy-content
		width 100%
		max-width 600px
		padding 30px
		margin 0px auto 0px auto

		p
			margin-bottom 20px

</style>



// WEBPACK FOOTER //
// src/components/privacy/privacy.vue